.productGridContainer {
  padding: 16px 16px 0;
}

@media all and (--reefer-media-tablet-min) {
  .productGridContainer {
    padding: 8px 0 0;
  }
}
